
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 102.36 149.55"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Layer_2","data-name":"Layer 2"}},[_c('g',{attrs:{"id":"CRS"}},[_c('g',{attrs:{"id":"CRS_Main_Icon","data-name":"CRS Main Icon"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M83.78 55.19a23.24 23.24 0 00-32.84 0L18.58 87.55a23.22 23.22 0 0032.84 32.84L83.78 88a23.24 23.24 0 000-32.81zm-16.91 45.37c-1.09-4.9-5.75-11.56-11.34-17.12S43.31 73.19 38.41 72.1l14.72-14.72a20.13 20.13 0 0128.46 28.47z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M97.14 13.5H63.76v.81c0 4.52 4 7.75 8.82 9.89h25v120.65H4.7V24.2h24.12c4.79-2.14 8.82-5.37 8.82-9.89v-.81H5.22A5.22 5.22 0 000 18.72v125.6a5.23 5.23 0 005.22 5.23h91.92a5.23 5.23 0 005.22-5.23V18.72a5.22 5.22 0 00-5.22-5.22z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M50.72 19a5.89 5.89 0 005.89-5.53H44.82a5.91 5.91 0 005.9 5.53z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M95.85 37.46H5.59l.26-1.53v-.32c1-7.57 5.34-9.21 8.77-9.26A41 41 0 0028.29 23c3.67-1.64 8.05-4.49 8.05-8.7v-.89A14.32 14.32 0 0150.65 0h.14a14.33 14.33 0 0114.28 13.42v.89c0 4.21 4.37 7.06 8.05 8.7a40.89 40.89 0 0013.62 3.34c3.44 0 7.75 1.69 8.77 9.26v.32zM8.66 34.85h84.11c-.53-2.76-1.87-5.83-6-5.89a43.3 43.3 0 01-14.69-3.56c-6.28-2.82-9.59-6.65-9.59-11.09v-.73a11.71 11.71 0 00-11.65-11h-.16a11.72 11.72 0 00-11.68 11v.73c0 4.44-3.32 8.27-9.6 11.09A43.31 43.31 0 0114.7 29c-4.16 0-5.5 3.09-6.04 5.85zm42.06-14.51a7.23 7.23 0 01-7.2-6.76v-.08-.38a7.22 7.22 0 0114.44 0v.46a7.23 7.23 0 01-7.24 6.76zm0-11.83a4.62 4.62 0 00-4.61 4.61 1.34 1.34 0 000 .2v.1a4.6 4.6 0 009.19 0v-.1-.2a4.62 4.62 0 00-4.58-4.61z"}})])])])])
          )
        }
      }
    